import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { resourceShape } from 'components/helpers/serialisableResources';

export default function CategoriesAffectedTooltip({
  categories,
  division,
  riskAssessment,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix:
      'riskRegister.sharedResourceNotices.components.shared.CategoriesAffectedTooltip',
  });

  return (
    <div className='tw-text-left'>
      <span>
        {i18nT('title', {
          divisionName: division.attributes.name,
          interpolation: { escapeValue: false },
          riskAssessmentName: riskAssessment.attributes.name,
        })}
        <ul className='tw-pl-5'>
          {categories.map((category) => (
            <li key={category.id}>{category.attributes.name}</li>
          ))}
        </ul>
      </span>
    </div>
  );
}

CategoriesAffectedTooltip.propTypes = {
  categories: PropTypes.arrayOf(resourceShape('trade')).isRequired,
  division: resourceShape('company'),
  riskAssessment: resourceShape('masterActivity'),
};
